import React from "react";
import moment from "moment";
import { amplitudeLogBasic } from "lib/general-helper";

export const logUpdateProfile = (overviewData) => {
  if (overviewData) {
    let win, ageInMin, kda;
    const { matchSummary } = overviewData || {};
    const { fetchPlayerMatchSummaries } = (matchSummary && matchSummary.data) || {};
    const { matchSummaries } = fetchPlayerMatchSummaries || {};
    if (matchSummaries && matchSummaries.length > 0) {
      const lastMatch = matchSummaries[0];
      win = lastMatch.win;
      ageInMin = moment().diff(moment(lastMatch.matchCreationTime + lastMatch.matchDuration * 1000), "minutes");
      if (lastMatch.deaths === 0) {
        if (lastMatch.kills === 0 && lastMatch.assists === 0) {
          kda = null;
        } else {
          kda = "perfect";
        }
      } else {
        kda = (lastMatch.kills + lastMatch.assists) / lastMatch.deaths;
      }
    }
    amplitudeLogBasic("update-profile", { win, ageInMin, kda });
  }
};

export const logUpdateNewMatchesCount = (newMatches) => {
  if (newMatches) {
    amplitudeLogBasic("update-new-matches-count", { new: newMatches.length });
  }
};
